module.exports = __webpack_public_path__ + "media/customizations/regencyatfolsomranch/back-7433b8e83d722a70d220e045c8a9dc20.jpg";